import { useAppBuilderContext } from 'app/app/editor/context';
import { Box } from '@mui/material';
import styles from 'app/app/editor/index.styles';

export default function NodeCssElement({
    element,
    uid,
    componentUid,
}: {
    element: any;
    uid: string;
    componentUid: string;
}) {
    const ctx = useAppBuilderContext();
    const [componentQuerySelector, editComponent] = [ctx.componentQuerySelector, ctx.editComponent];
    const isMatch = componentUid == uid && element.querySelector == componentQuerySelector;

    return (
        <Box sx={{ marginLeft: '10px' }}>
            {element.title && (
                <Box
                    sx={isMatch ? styles.highlighted : {}}
                    component={'span'}
                    onClick={() => {
                        editComponent({ uid: uid, querySelector: element.querySelector });
                    }}
                >
                    {element.title}
                </Box>
            )}
            {element.elements &&
                element.elements.map((element: any, k: number) => (
                    <NodeCssElement key={k} element={element} uid={uid} componentUid={componentUid} />
                ))}
        </Box>
    );
}
